/*
  <recipient-form> — controla el formulario de destinatario de gift card.
  - Habilita/deshabilita los campos segun el checkbox (los deshabilitados NO se envian,
    asi el bono se comporta normal cuando no se marca).
  - Setea la zona horaria del cliente para la fecha de envio.
  - Valida que el email del destinatario exista y sea valido antes de agregar al carrito.
*/
if (!customElements.get('recipient-form')) {
  customElements.define(
    'recipient-form',
    class RecipientForm extends HTMLElement {
      constructor() {
        super();
        this.checkbox = this.querySelector('[data-recipient-checkbox]');
        this.fields = this.querySelector('[data-recipient-fields]');
        this.controls = this.querySelectorAll('[data-recipient-control]');
        this.emailInput = this.querySelector('[data-recipient-email]');
        this.errorEl = this.querySelector('[data-recipient-error]');
        this.offsetInput = this.querySelector('[data-recipient-offset]');
        this.form = this.closest('form');

        this.onToggle = this.onToggle.bind(this);
        this.onSubmit = this.onSubmit.bind(this);

        if (this.checkbox) this.checkbox.addEventListener('change', this.onToggle);
        // Capturamos submit Y click del boton ANTES que el theme (fase captura),
        // para bloquear el add-to-cart AJAX si el email del destinatario falta.
        if (this.form) {
          this.form.addEventListener('submit', this.onSubmit, true);
          const addBtn = this.form.querySelector('[name="add"]');
          if (addBtn) addBtn.addEventListener('click', this.onSubmit, true);
        }

        this.onToggle();
      }

      get isOn() {
        return this.checkbox && this.checkbox.checked;
      }

      onToggle() {
        const on = this.isOn;
        if (this.fields) this.fields.hidden = !on;
        this.controls.forEach((el) => {
          el.disabled = !on;
        });
        if (on && this.offsetInput) {
          this.offsetInput.value = new Date().getTimezoneOffset();
        }
        if (!on) this.clearError();
      }

      onSubmit(event) {
        if (!this.isOn) return;
        const email = (this.emailInput && this.emailInput.value || '').trim();
        const valid = /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email);
        if (!valid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.showError();
          if (this.emailInput) this.emailInput.focus();
        } else {
          this.clearError();
        }
      }

      showError() {
        this.classList.add('is--error');
        if (this.errorEl) this.errorEl.hidden = false;
      }

      clearError() {
        this.classList.remove('is--error');
        if (this.errorEl) this.errorEl.hidden = true;
      }
    }
  );
}
